import { Box } from "@mui/material";
import { FC, useState } from "react";
import { CalendarViewProps } from "../types";
import { getInitialSelectedYear, overWriteStartDate } from "../utils";
import { MonthsGrid } from "./MonthsGrid";
import { YearPicker } from "./YearPicker";

export const MonthView: FC<CalendarViewProps> = ({
  tempStartDate,
  tempEndDate,
  setTempStartDate,
  setTempEndDate,
  earliestSelectableDate,
}) => {
  const [selectedYear, setSelectedYear] = useState<number>(
    getInitialSelectedYear(tempEndDate),
  );

  const handleMonthSelect = (monthIndex: number) => {
    const selectedMonthDate = new Date(Date.UTC(selectedYear, monthIndex, 1));

    if (!tempStartDate || tempEndDate) {
      const selectedFirstDay = new Date(Date.UTC(selectedYear, monthIndex, 1));
      const firstDay = overWriteStartDate(
        selectedFirstDay,
        earliestSelectableDate,
      );
      setTempStartDate(firstDay);
      setTempEndDate(null);
    } else {
      const potentialStart = overWriteStartDate(
        selectedMonthDate,
        earliestSelectableDate,
      );

      if (potentialStart.getTime() >= tempStartDate.getTime()) {
        const lastDay = new Date(Date.UTC(selectedYear, monthIndex + 1, 0));
        setTempEndDate(lastDay);
      } else {
        const firstDay = overWriteStartDate(
          new Date(Date.UTC(selectedYear, monthIndex, 1)),
          earliestSelectableDate,
        );
        setTempStartDate(firstDay);
        setTempEndDate(null);
      }
    }
  };

  return (
    <Box>
      <YearPicker
        earliestSelectableDate={earliestSelectableDate}
        onYearChange={setSelectedYear}
        selectedYear={selectedYear}
      />
      <MonthsGrid
        earliestSelectableDate={earliestSelectableDate}
        endDate={tempEndDate}
        onMonthSelect={handleMonthSelect}
        selectedYear={selectedYear}
        startDate={tempStartDate}
      />
    </Box>
  );
};
